export const appendSciLink = (url: string | undefined): string | undefined =>
    url ? `${url}${url.includes('?') ? '&' : '?'}sciLink=true` : url;
